/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScoringOverrideDTO } from './scoring-override-dto';
import { PraticaEditSessionSnapshotDTO } from './pratica-edit-session-snapshot-dto';
import { RichiedenteCompactDTO } from './richiedente-compact-dto';


export interface PraticaOperatoreSummaryDTO { 
    id?: string;
    codice_pratica?: string;
    richiedente?: RichiedenteCompactDTO;
    stato_dettaglio?: PraticaOperatoreSummaryDTOStatoDettaglioEnum;
    timestamp_richiesta?: string;
    caricata_da_operatore?: boolean;
    caricata_da_operatore_nome?: string;
    punteggio_pratica?: number;
    codice_anpr?: string;
    codice_anpr_modificabile?: boolean;
    inizio_lavorazione?: string;
    timestamp_conferma_pratica?: string;
    origine_richiesta?: PraticaOperatoreSummaryDTOOrigineRichiestaEnum;
    version?: number;
    scoring_override?: ScoringOverrideDTO;
    edit_session?: PraticaEditSessionSnapshotDTO;
}
export enum PraticaOperatoreSummaryDTOStatoDettaglioEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};
export enum PraticaOperatoreSummaryDTOOrigineRichiestaEnum {
    OPERATORE_SUPPORTO = 'OPERATORE_SUPPORTO',
    CITTADINO = 'CITTADINO'
};



